$(document).ready(function () {
  // Announcement Bar Slider
  if ($(".announcement--wrapper")) {
    $(".announcement--wrapper").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      infinite: true,
      swipeToSlide: true,
      vertical: true,
      autoplaySpeed: 2000,
      arrows: false,
    });
    $(".announcement--wrapper").slick("slickPlay");
  }

  $("body").on(
    "click",
    ".bottle-case-buy-button .pre-mix-bundle-button",
    async function () {
      var checkedElement = $(this)
        .parents(".tab-bar")
        .find('.bottle--main input[type="radio"]:checked');
      var prodId = $(this).data("prod-id");
      var quantity = checkedElement.val();
      var id = checkedElement.attr("id");
      $(this).addClass("hidden");
      console.log("Change", $(this), checkedElement, quantity);

      // var property = `${id}-${quantity}--${Date.now()}`;
      var t = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: prodId, quantity: quantity }] }),
      };
      try {
        await theme.cart.addItem(t, null),
          theme.drawer.open("right", "cart-drawer", this);
        $(this).removeClass("hidden");
      } catch (t) {
        throw ($(this).removeClass("hidden"), new Error(t));
      }
    }
  );
});

// PDP custom js
$(document).ready(function () {
  let casePrice = document.querySelector(".product-price--cases");
  let originalPrice = document.querySelector(".product-price--original");
  let radioBtn = document.querySelectorAll(".radios--input");
  let selectBtn = document.querySelector(".cases-btn");
  let addtoCart = document.querySelector(".add-btn");
  
  let disclosure = document.querySelectorAll(".product--quick-add--icon");

  if (casePrice) {
    if (radioBtn) {
      radioBtn.forEach((rb) => {
        rb.onchange = () => {
          casePrice.classList.add("hide");
          originalPrice.classList.remove("hide");
          selectBtn.classList.add("hide");
          addtoCart.classList.remove("hide");
        };
      });
    }
  }
disclosure.forEach((icon) => {
  icon.onclick = () => {
    setTimeout(() => {
      const disSelect = document.querySelectorAll(".disclosure--option");
      const casePrice1 = document.querySelectorAll(".product-price--cases");
      const originalPrice1 = document.querySelectorAll(".product-price--original");
      const selectBtn1 = document.querySelectorAll(".cases-btn");
      const addtoCart1 = document.querySelectorAll(".add-btn");

      if (casePrice1.length > 0 && disSelect.length > 0) {
        disSelect.forEach((db) => {
          db.onclick = () => {
            casePrice1.forEach((price) => price.classList.add("hide"));
            originalPrice1.forEach((original) => original.classList.remove("hide"));
            selectBtn1.forEach((btn) => btn.classList.add("hide"));
            addtoCart1.forEach((btn) => btn.classList.remove("hide"));
          };
        });
      }
    }, 1000);
  };
});

  // disclosure.forEach((icon) => {
  //   icon.onclick = () => {
  //     setTimeout(() => {
  //       let disSelect = document.querySelectorAll(".disclosure--option");
  //         let casePrice1 = document.querySelector(".product-price--cases");
  // let originalPrice1 = document.querySelector(".product-price--original");
  // let selectBtn1 = document.querySelector(".cases-btn");
  // let addtoCart1 = document.querySelector(".add-btn");
  //       if (casePrice1) {
  //         if (disSelect) {
  //           disSelect.forEach((db) => {
  //             db.onclick = () => {
  //               casePrice1.classList.add("hide");
  //               originalPrice1.classList.remove("hide");
  //               selectBtn1.classList.add("hide");
  //               addtoCart1.classList.remove("hide");
  //             };
  //           }); 
  //         }
  //       }
  //     }, 1000);
  //   };
  // });
});
